export { default } from './SettingsLicense.jsx';
